import { snapKindLabel } from '@entities/geodesy';
import { glyphPath, snapGlyph, type PreviewSnap } from '../snap';
import { HOT_SCALE } from './types';

/** Активная точка прилипания: кольцо, крупный значок и подпись «к чему прилипнет». */
export function HotSnap({ s, k, flip }: { s: PreviewSnap; k: number; flip: boolean }) {
  const glyph = snapGlyph(s.snap.kind);
  const d = glyphPath(glyph, s.px, s.py, k * HOT_SCALE);
  const gap = 12 * k;
  return (
    <g className="hot" aria-hidden="true">
      <circle className="hot-ring" cx={s.px} cy={s.py} r={10 * k} />
      {glyph === 'dot' ? (
        <path className="hot-dot" d={d} />
      ) : (
        <>
          <path className="hot-halo" d={d} />
          <path className="hot-line" d={d} />
        </>
      )}
      <text
        className="hot-label"
        x={flip ? s.px - gap : s.px + gap}
        y={s.py - gap}
        fontSize={12 * k}
        textAnchor={flip ? 'end' : 'start'}
      >
        {snapKindLabel(s.snap)}
      </text>
    </g>
  );
}
